import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from "/src/views/App";


const container = document.getElementById('app');
const root = createRoot(container);

root.render(
    <BrowserRouter>
        <App data={{}} />
    </BrowserRouter>
);
